import styled from '@emotion/styled'

export const StyleFormWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  position: relative;
  width: 100%;
  .ql-editor {
    min-height: 200px;
  }
  ${(props) => props.styleWrapper}
`
export const StyleErrorMessage = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.danger};
`
export const StylePlaceholder = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.placeholder};
`

export const StyleLabel = styled.label<any>`
  font-size: 14px;
  color: ${(props) =>
    props?.hasError ? props.theme.colors.danger : props.theme.colors.black};
  ${(props) => props.styleLabel}
`

export const StyleFormRowWrapper = styled.div<any>`
  display: flex;
  width: 100%;
  row-gap: 20px;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 16px;
  }
  ${(props: any) => props.customStyle}
`
export const StyleFormFieldWrapper = styled.div<any>`
  display: flex;
  flex-direction: row;

  width: ${(props: any) => (props.width ? props.width : 32)}%;
  ${(props: any) => props.customStyle}
  @media (max-width: 767px) {
    width: 48%;
  }
  @media (max-width: 640px) {
    width: 100%;
  }
`
